'use client'

import { Container } from 'react-bootstrap'
// import Header from '@/widgets/Header'
import Footer from '@/widgets/Footer'
// import Chat from '@/entities/Chat'
import { useGetIsAuthUser } from '@/shared/hooks/useGetIsAuthUser.js'
import { useScrollTop } from '@/shared/hooks/useScroll.jsx'
// import {useEffect} from "react";
import dynamic from 'next/dynamic'

const Header = dynamic(() => import('@/widgets/Header'), {
    ssr: false,
})

export const LayoutPage = ({ children }) => {
    useScrollTop()

    return (
        <div className={'LayoutPage'}>
            {/*<Chat/>*/}
            <Header />
            <main className={'content'}>
                <Container>{children}</Container>
            </main>
            <Footer />
        </div>
    )
}
